<!--秒杀活动界面-->
<template>
  <div>
    <!--没有登录或者登录后没有电视源-->
    <pre-login
      v-if="!source"
      :userInfo="userInfo"
      :token="token"
      :source="source"
      @handleLogin="$constants.onLogin()"
      @insertActive="handleActive"
    >
    </pre-login>
    <sec-kill-page
      v-else
      :source="source"
      :userInfo="userInfo"
      @handleLogin="$constants.onLogin()"
    ></sec-kill-page>

  </div>
</template>

<script>
import PreLogin from '../sellCard/PreLogin'
import secKillPage from './secKillPage'
import service from '@/service'
export default {
  name: 'secKillCard',
  created () {
    let token = JSON.parse(localStorage.getItem('accessTokenInfo'))
    this.token = token ? token.access_token : ''
    this.userInfo = token ? JSON.parse(localStorage.getItem('userinfo')) : {}
  },
  data () {
    return {
      source: null,
      token: '',
      timer: null,
      userInfo: {
        nick_name: '默认账号',
        avatar: require('@/assets/images/sellCard/sellCard-avatar.jpeg')
      },
      flag: true
    }
  },
  mounted () {
    if (this.token) {
      // 调用电视源接口 查看当前用户是否有电视源
      this.getDeviceList()
      // 定时请求设备数据源
      this.timer = setInterval(this.getDeviceList, 5000) // 暂时去掉
      // 组件销毁时销毁定时器
      this.$once('hook:destroyed', () => {
        clearInterval(this.timer)
      })
      // 为了测试清除浏览器缓存
      // localStorage.removeItem('accessTokenInfo')
      // localStorage.removeItem('userinfo')
    }
  },
  methods: {
    async getDeviceList() {
      let params = {
        client_id: 'activitycenter',
        key: '7fa0c44c6ecf8228ef067c1cc624be2d',
        param: {
          openid: this.userInfo.open_id
          // openid: '758a9827be904000b39f4476a0d4131f'
        }
      }
      try {
        // 获取数组最新数据源
        let data = await service.getDeviceList(params)
        const len = data.length
        // 增加曝光埋点
        const dataObj = {
          login_type: localStorage.getItem('loginType'),
          account_state: this.token ? 'login' : '',
          open_id: this.userInfo.open_id,
          scenario: '支付登录',
          login_type_count: '支持1/2/4种登录方式',
          title: !this.token ? '登录引导页' : len > 0 ? this.$route.meta.title : '登录电视端引导页面'
        }
        window._cooc && window._cooc.push(['_trackEvent', 'miaosha_page_view_event', '浏览', dataObj])
        if (data.length > 0) {
          for (let i = 0; i < len; i++) {
            if (data[i].source === 'yinhe' && data[i].usersToDevice.onlineFlag === 1) {
              this.source = 'yinhe'
              clearInterval(this.timer)
              return
            } else if (data[i].source === 'tencent' && data[i].usersToDevice.onlineFlag === 1) {
              this.source = 'tencent'
              clearInterval(this.timer)
              return
            }
          }
        } else {
          if (this.flag) {
            // 将用户信息推送给后端保存
            let params = {
              client_id: 'activitycenter',
              key: '7fa0c44c6ecf8228ef067c1cc624be2d',
              param: { openId: this.userInfo.open_id }
            }
            this.$service.setUserInfoToDBA(params)
          }
          this.flag = false
        }
      } catch (e) {
        this.$toast({
          type: 'fail',
          message: '暂未获取数据源信息，请稍后！'
        })
      }
    },
    handleActive(source) {
      this.source = source
    },
    handleLogin () {
      if (this.source === 'tencent') {
        this.$constants.onLogin('weixin,qq')
      } else {
        this.$constants.onLogin()
      }
    }
  },
  components: {
    PreLogin,
    secKillPage
  }
}
</script>

<style scoped>

</style>
